import React from "react";
import ReactDOM from "react-dom/client";
import { GoogleOAuthProvider } from '@react-oauth/google';
import "./index.css";
import App from "./App";
import { installAuthInterceptors } from "./lib/authToken";

// Habilita auth por header Bearer (además de la cookie) para escenarios
// cross-site donde la cookie no viaja (dev-rd.cloud → api.redmobility.net).
installAuthInterceptors();

// Client ID de Google OAuth (es público, no es secreto: viaja en el bundle del navegador).
// El valor por defecto es el ID de producción de RedMobility; se puede sobreescribir con la env.
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "619633492150-aoi1loiepkskblmdu8je2hkqgjrrofl7.apps.googleusercontent.com";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>,
);
